import styled from 'styled-components';

export const AgreementCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

export const AgreementInfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AgreementLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  line-height: 20px;
`;

export const AgreementValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  line-height: 24px;
`;

export const NoticeText = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  margin: 0;
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.buttonButtonPrimarySecondary2100};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
